module.exports = __webpack_public_path__ + "MH.png?bb4b9d4baf6195ace2aa13159f067d68";